import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slice/authSlice";
import dashboardSlice from "./slice/dashboardSlice";
import parentSlice from "./slice/parentSlice";
import tutorSlice from "./slice/tutorSlice";
import allListsSlice from "./slice/allListsSlice";
import subAdminSlice from "./slice/subAdminSlice";
import bookingSlice from "./slice/bookingSlice";
import couponCodeSlice from "./slice/couponCodeSlice";
import subscriptionPlanSlice from "./slice/subscriptionPlanSlice";
import badgeSlice from "./slice/badgeSlice";
import reportedBookingsSlice from "./slice/reportedBookingsSlice";
import reviewSlice from "./slice/reviewSlice";
import cmsSlice from "./slice/cmsSlice";
import faqSlice from "./slice/faqSlice";
import notificationSlice from "./slice/notificationSlice";
import earningSlice from "./slice/earningSlice";
import settlementSlice from "./slice/settlementSlice";
import refundSlice from "./slice/refundSlice";

export const store = configureStore({
    reducer: {
        auth: authSlice,
        dashboard: dashboardSlice,
        parent: parentSlice,
        tutor: tutorSlice,
        allLists: allListsSlice,
        subAdmin: subAdminSlice,
        booking: bookingSlice,
        earning: earningSlice,
        refund: refundSlice,
        couponCode: couponCodeSlice,
        subscriptionPlan: subscriptionPlanSlice,
        badge: badgeSlice,
        reportedBooking: reportedBookingsSlice,
        review: reviewSlice,
        cms: cmsSlice,
        faq: faqSlice,
        notification: notificationSlice,
        settlement: settlementSlice,
    },
    devTools: process.env.NODE_ENV === 'development',
});